class EventAddFormController {
  constructor() {

  }
}

export default EventAddFormController;
